import { render, staticRenderFns } from "./BankCreate.vue?vue&type=template&id=61bd8280&"
import script from "./BankCreate.vue?vue&type=script&lang=js&"
export * from "./BankCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports